import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import BreadcrumbItem from '../../commonComponents/breadcrumb/breadcrumbItem';

const { homeLink } = window.inlineProductDetails;

const Breadcrumbs = ({ breadcrumbs }) =>
  breadcrumbs.length ? (
    <div className="breadcrumbs-container">
      <ol className="breadcrumbs" itemScope itemType="http://schema.org/BreadcrumbList">
        <li className="breadcrumbs__item" itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
          <a className="js-tracking-breadcrumbs" itemProp="item" href={homeLink}>
            <span itemProp="name">
              <FormattedMessage id="breadcrumb.root" description="Home" />
            </span>
          </a>
          <meta itemProp="position" content="1" />
        </li>
        {breadcrumbs.map((breadcrumb, index) => (
          <BreadcrumbItem {...breadcrumb} index={index} />
        ))}
      </ol>
    </div>
  ) : null;

Breadcrumbs.defaultProps = {
  breadcrumbs: [],
};

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array,
};

export default Breadcrumbs;
